<template>
  <div class="">
    <b-button
      v-b-toggle.ReservationsSchedulesPayments
      class="btn btn-lg btn-collapse"
    >
      {{ $t("pages.ReservationsSchedulesPayments") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="ReservationsSchedulesPayments">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsSchedulesPaymentsView"
              v-model="
                usersPrivilegeReservationsSchedulesPayments.reservationsSchedulesPaymentsView
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="reservationsSchedulesPaymentsView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsSchedulesPaymentsAdd"
              v-model="
                usersPrivilegeReservationsSchedulesPayments.reservationsSchedulesPaymentsAdd
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="reservationsSchedulesPaymentsAdd">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsSchedulesPaymentsRefund"
              v-model="
                usersPrivilegeReservationsSchedulesPayments.reservationsSchedulesPaymentsRefund
              "
              class="checkbox"
            />
            <label
              class="mt-1 ml-2"
              for="reservationsSchedulesPaymentsRefund"
              >{{ $t("refund") }}</label
            >
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeReservationsSchedulesPayments",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeReservationsSchedulesPayments"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
